import { aboutbg } from "../Assets";
import { motion } from "framer-motion";

const About = () => {
  return (
    <section id="about"
      className="w-full px-4 sm:px-6 md:px-8 py-36 sm:py-24 md:py-48 lg:py-64 text-white relative overflow-hidden"
      style={{
        backgroundImage: `url(${aboutbg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.div
        className="max-w-4xl mx-auto space-y-10 relative z-10"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-center">
          ABOUT Nad Trading Bot
        </h2>

        {/* Sub Title 1 */}
        <motion.h4
          className="text-lg sm:text-xl md:text-3xl text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Trade at the Speed of Thought
          <br />
          Every trader wants an edge.
          <br />
          NTB gives it to you, fast, fearless, and fully on-chain.
        </motion.h4>

        {/* Text Box 1 */}
        <motion.p
          className="bg-white/10 text-center backdrop-blur-md text-white p-6 rounded-xl text-sm sm:text-base md:text-lg leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Nad Trading Bot is a Telegram-native trading bot built for traders
          who move fast. It brings the full power of Monad’s DeFi ecosystem
          right into your chat, enabling lightning-fast swaps, limit orders,
          portfolio tracking, and more.
        </motion.p>

        {/* Text 2 */}
        <motion.p
          className="text-sm text-center sm:text-base md:text-lg leading-relaxed text-gray-200"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          Powered by Monadscore intelligence, NTB delivers real-time data,
          optimized routing, and built-in safety checks, giving you a serious
          edge in every trade.
        </motion.p>

        {/* Sub Title 2 */}
        <motion.h4
          className="text-lg sm:text-xl md:text-3xl text-center"
          style={{ color: "#F458FF" }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          Your on-chain command center, built to move faster, trade smarter,
          and win harder.
        </motion.h4>

        <hr className="border-[#F458FF] my-10 w-1/2 mx-auto" />
      </motion.div>
    </section>
  );
};

export default About;